module.exports = __webpack_public_path__ + "static/mediaservis-6dae407ad1a551e2199ed1e0766e9d31.png";